import React, { useEffect } from 'react'
import { withRouter, RouteComponentProps } from 'react-router-dom'

interface ScrollToTopProps extends RouteComponentProps {
  children: React.ReactNode
}

const ScrollToTop = ({ location, children }: ScrollToTopProps): React.ReactElement => {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [location])

  return <>{children}</>
}

export default withRouter(ScrollToTop)
